import { createContext, FC, useCallback, useContext, useState } from 'react';

type ScanLoadingStatus = {
  packages: boolean;
  media: boolean;
  storage: boolean;
};

type ContextType = {
  loading: boolean;
  setStatus: (name: CleanupTool, loading: boolean) => void;
};

export type CleanupTool = 'packages' | 'storage' | 'media';

const tools: CleanupTool[] = ['packages'];

const initial = {
  packages: false,
  media: false,
  storage: false,
};

const Context = createContext<ContextType>({
  loading: false,
  setStatus: () => {},
});

export function useTools() {
  return tools;
}

export function useDiskCleanup() {
  return useContext(Context);
}

const DiskCleanupContext: FC = ({ children }) => {
  const [state, setState] = useState<ScanLoadingStatus>(initial);

  const loading = state.packages || state.media || state.storage;

  const setStatus = useCallback((name: CleanupTool, loading: boolean) => {
    setState(current => ({
      ...current,
      [name]: loading,
    }));
  }, []);

  return (
    <Context.Provider value={{ loading, setStatus }}>
      {children}
    </Context.Provider>
  );
};

export default DiskCleanupContext;
